import React, {useState, useEffect } from 'react'
import Header from '../common/Header'
import Footer from '../common/Footer';
import Card from '../home/Card_Wraper'
import Map from './Map';
import BuyAdds from './BuyAdds';
import Circle from './circle';
import { scrollHandler } from '../../util/animation';
import Blink from 'react-blink-text';
import { animations } from 'react-animation';
import { endPoints } from "../../config";
import { axiosInstnace as axios } from "../../util/util";


const App = () => {
  const [w, handleWidth]=useState(775);
  const [cardStatus, handleCardStatus] = useState(false);
  const [showSplash, handleShowSplash] = useState(false);
  const [splashData, handleSplashData] = useState(undefined);
  const [hideAnimate, handleHideAnimate] = useState(false);
  
 
  window.scrollTo(0,0)

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler);
    getCurrentSplashScreen();
    return () => {
      window.removeEventListener('scroll', scrollHandler)
    };
  }, []);

  //Checking the window width
  useEffect(()=>{
    if(window.outerWidth > 1660){
      handleWidth(775);
    }
    else if(window.outerWidth > 1279 && window.outerWidth < 1660){
      handleWidth(650);
    }
    else {
      handleWidth(550);  
    }
  },[window.outerWidth])

  //Render card
  const renderCard = status =>{
    handleCardStatus(status);
  }
  window.scrollTo(0, 0);

  const getCurrentSplashScreen = async () => {
    const splashScreenResponse = await axios.get(endPoints.getCurrentSplashScreen);

    if( splashScreenResponse.data && splashScreenResponse.data.data && splashScreenResponse.data.data.message == "No splash screen" ){
      handleShowSplash(false);
      handleSplashData(undefined);
    }
    else if(splashScreenResponse.data && splashScreenResponse.data.data.data){
      handleSplashData(splashScreenResponse.data.data.data);
      handleShowSplash(true);
      handleHideAnimate(false);
      if(splashScreenResponse.data.data.data.autoclose){
        setTimeout(() => {
          handleShowSplash(false);
        }, (splashScreenResponse.data.data.data.autoclosetimeout * 1000));
      }
    }
  }

  const showSplashScreen = () => {
    if(splashData){
      handleHideAnimate(false);
      handleShowSplash(true);
    }
  }
  /**
   * Render method return Different component
   * such as Card, Header, Map etc.
   */
  return (
    <div className="main_wrapper home_wrapper">
     <Circle />
     <Header showSplash  splashData />  

     { !showSplash && splashData && (
        <span className="splash-minimize blink" onClick={ showSplashScreen }>
          New!
        </span>
      )}
    { showSplash && splashData && (
      <div id="splash_screen_wrapper">
        <div className="splash_screen_container">
          <span className="close_btn" onClick={ ()=> { handleHideAnimate(true); setTimeout(() => {
            handleShowSplash(false);
          }, 1000); } }>x</span>
          <div className={"splash_screen "+ ( hideAnimate ?"animated-hide" : "")}>
            { splashData.template == 'template1' && (
              <div className="template_1">
                <div className="leftside">
                  <img src={ splashData.splashImage } alt={ splashData.heading } />
                </div>
                <div className="rightside">
                  <h2>{ splashData.heading }</h2>
                  <p>{ splashData.description }</p>

                  { splashData.showbutton && (
                    <div className="button_container">
                      <a href={ `/contact?splashid=${splashData._id}` } className="button">{ splashData.buttontext }</a>
                    </div>
                  )}
                </div>
              </div>
            )}
            { splashData.template == 'template2' && (
              <div className="template_2">
                <div className="center">
                  <img src={ splashData.splashImage } alt={ splashData.heading } />

                  <div className="content_container">
                    <h2>{ splashData.heading }</h2>
                    <p>{ splashData.description }</p>

                    { splashData.showbutton && (
                      <div className="button_container">
                        <a href={ `/contact?splashid=${splashData._id}` } className="button">{ splashData.buttontext }</a>
                      </div>
                    )}
                  </div>
                </div>
              </div>  
            )}
            
            
          </div>
        </div>
      </div>
    )}
      
      <div className="buy_ads_wrapper">
       <BuyAdds />     
        <div className="buy_ads_right">
          <div className="map_wrapper">
          <div className="map-title"> <Blink color='yellow' text='Click on the India map to buy a package' fontSize='21'>   </Blink> </div>
          <Map w={w} renderCard={renderCard}/>
          </div>
        </div>
      </div>
      {cardStatus &&<div className="why_radio_wrapper">
        <div className="grid-img">
          <img src="../../assets/images/dots.png" />
        </div>
        <div className="home_card_text">
          <div className="text_inner">Why <span>Radio</span></div>
        </div> 
       <Card />
      </div>}
      {cardStatus && <Footer />}
    </div>
  );
  }


export default App;


// WEBPACK FOOTER //
// ./web/components/home/Home.jsx